import React from "react";

const ViewNotPublic = () => (
  <div className="viewer-screen">
    <p className="title-centered">
      <span className="smile">:(</span>
      Výstava není ve stavu "Zveřejněná" nebo zadaná URL adresa výstavy
      neexistuje.
    </p>
  </div>
);

export default ViewNotPublic;



// WEBPACK FOOTER //
// ./src/containers/views/ViewNotPublic.js